import React, { useState } from 'react';
import AAUpload from './AAUpload';
import { Button, Modal } from 'antd';
import { ServerAPI } from '../common/ServerAPI';
import { toast } from 'react-toastify';

const SelfAAUpload = ({ open, close,reloadData }) => {
    const [selfAA, setSelfAA] = useState([]);

    const statusUpdate = async (statusData) => {
        console.log(statusData,'}}}}}}}}}');
        const response = await ServerAPI.updateProductStatus(statusData);
        if (response) {
            toast.success(response.message);
            close();
            reloadData();
        }
    }
    return (
        <Modal title={"Upload AA"} centered footer={false} open={open} onCancel={close}>
            <div className='flex justify-center'>
                <div className="bg-white p-4">
                    <div className='text-center'>
                        <p className='text-15px font-[400] mb-3'>If you have your own AA documents, select the files to upload (max 1 file)</p>
                    </div>
                    <AAUpload setSelfAA={setSelfAA} />
                    <div className='text-center'>
                        <Button disabled={(selfAA.length == 0) ? true : false} onClick={() => {
                            let data = JSON.parse(localStorage.getItem('statusData'));
                            data['aa_files'] = selfAA;
                            statusUpdate(data);
                        }} type='primary mt-2'>Save</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default SelfAAUpload;